import { Col, Row } from "antd";
import { useState } from "react";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";
import { FileUploadConst } from "./constants";
import InputComponent from "../../../components/InputComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";

const DocumentDetail = () => {
	const { documentForm, setDocumentForm } = useDocumentContext();
	const [selectedFileCount, setSelectedFileCount] = useState(0);
	const isSingleFileSelected = selectedFileCount === 1;
	const [documentName, setDocumentName] = useState<string>("");

	const handleFileChange = (files: FileData[] | null) => {
		const count = files?.length ?? 0;
		const singleFileName = files?.[0]?.file?.name?.replace(/\.[^/.]+$/, "") ?? "";
		setSelectedFileCount(count);
		setDocumentName(count === 1 ? singleFileName : "");

		setDocumentForm(prevState => ({
			...prevState,
			documents: files?.map(file => file.file).filter(f => f !== null) as File[] || [],
		}));
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<FileUploadComponent
						title={FileUploadConst.label}
						onChange={handleFileChange}
						maxFileSize={FileUploadConst.maxFileSize}
						allowedExtensions={FileUploadConst.extensions}
						isRequired
						multiple
						maxFileCount={50}
					/>
					{selectedFileCount > 1 && (
						<span style={{ color: "#6b7280", fontSize: "12px", display: "block", marginTop: "8px" }}>
							Birden fazla dosya yüklediğinizde doküman adları dosya isminden alınır.
						</span>
					)}
				</Col>
			</Row>
			{isSingleFileSelected && (
				<Row gutter={20}>
					<Col span={5}>
						<InputNumberComponent
							title={"Sıra No"}
							placeholder="1"
							positiveOnly
							value={documentForm?.displayOrder}
							onChange={(value) => setDocumentForm({ ...documentForm, displayOrder: Number(value) })}
						/>
					</Col>
					<Col span={15}>
						<InputComponent
							title={"Doküman Adı"}
							placeholder="Tamim No 5"
							value={documentName}
							onChange={(e) => {
								const nextValue = e.target.value;
								setDocumentName(nextValue);
								setDocumentForm({
									...documentForm,
									documentName: nextValue
								});
							}}
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

export default DocumentDetail;
